'use client';

import styled from 'styled-components';
import { colors } from '@/styles';

export const SchemaRail = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 25px 0 25px;
  gap: 10px;

  & > div {
    flex: 1;
    display: flex;
    position: relative;
  }
`;

export const FieldListContainer = styled.div`
  position: absolute;
  top: 0px;
  left: 1px;
  right: 1px;
  bottom: 1px;

  .field-list {
    max-height: 100%;
    overflow-y: auto;
    padding-bottom: 25px;
  }

  &:after {
    display: block;
    content: '';
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 1;
    pointer-events: none;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 95%);

    width: 100%;
    height: 50px;
  }
`;
